import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const roomTypeRateBoundariesApiConfig = {
  createRoomTypePricingConfig: {
    key: "createRoomTypePricingConfig",
    url: "/api/v1/pricing-caps",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: [
        "getRoomTypePricingConfigs",
        "getRoomTypeRateBoundaries",
      ],
      onSuccessMessage: "Pricing config created successfully",
      onErrorMessage: "Failed to create pricing config",
    },
  },

  getRoomTypePricingConfigs: {
    key: "getRoomTypePricingConfigs",
    url: "/api/v1/pricing-caps",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getRoomTypeRateBoundaries: {
    key: "getRoomTypeRateBoundaries",
    url: "/api/v1/pricing-caps",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  updateRoomTypePricingConfig: {
    key: "updateRoomTypePricingConfig",
    url: (data) => `/api/v1/pricing-caps/${data.id}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: [
        "getRoomTypePricingConfigs",
        "getRoomTypeRateBoundaries",
      ],
      onSuccessMessage: "Pricing config updated successfully",
      onErrorMessage: "Failed to update pricing config",
    },
  },

  deleteRoomTypePricingConfig: {
    key: "deleteRoomTypePricingConfig",
    url: (data) => `/api/v1/pricing-caps/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: [
        "getRoomTypePricingConfigs",
        "getRoomTypeRateBoundaries",
        "getDeletedRoomTypePricingConfigs",
      ],
      onSuccessMessage: "Pricing config deleted successfully",
      onErrorMessage: "Failed to delete pricing config",
    },
  },

  getDeletedRoomTypePricingConfigs: {
    key: "getDeletedRoomTypePricingConfigs",
    url: "/api/v1/pricing-caps/deleted",
    method: "GET",
    options: { ...QUERY_PRESETS.LIST },
  },

  restoreRoomTypePricingConfig: {
    key: "restoreRoomTypePricingConfig",
    url: (data) => `/api/v1/pricing-caps/${data.id}/restore`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: [
        "getRoomTypePricingConfigs",
        "getRoomTypeRateBoundaries",
        "getDeletedRoomTypePricingConfigs",
      ],
      onSuccessMessage: "Pricing cap restored successfully",
      onErrorMessage: "Failed to restore pricing cap",
    },
  },
};
